
    import { mapState } from 'vuex'
    import { Vue, Component, Inject } from 'vue-property-decorator'
    import { ProductDefinition } from '@/app/product/entities/product-definition.entity'
    import { ProductDefinitionMeta } from '@/app/product/entities/product-definition-meta.entity'
    import { GetProductDefinitionsCommand } from '@/app/product/commands/get-product-definitions.command'
    import { GetMyUploadedDocumentsCommand } from '@/app/my-uploaded-documents/commands/get-my-uploaded-documents.command'
    import { License } from '@/app/license/entities/license.entity'

    @Component({
        computed: {
            ...mapState('product', ['definitions']),
            ...mapState('license', ['license'])
        }
    })
    export default class MainMenu extends Vue {
        definitions!: ProductDefinition
        license!: License

        @Inject() getProductDefinitionsCommand!: GetProductDefinitionsCommand
        @Inject() getMyDocumentsCommand!: GetMyUploadedDocumentsCommand

        get documents() {
            return this.$store.state.myUploadedDocuments.documents
        }

        get hasLoaded() {
            return this.$store.state.myUploadedDocuments.hasLoaded
        }

        get showMyUploadedDocuments() {
            return !!(
                this.license &&
                this.license.features &&
                this.license.features.canViewUploadedDocuments &&
                this.hasLoaded &&
                this.documents &&
                this.documents.length > 0
            )
        }

        buildRoute(definition: ProductDefinitionMeta, listRoute: string, detailRoute: string): object {
            if (definition.counter > 1) {
                return { name: listRoute }
            }

            return { name: detailRoute, params: { id: definition.firstProductId } }
        }

        async mounted() {
            if (!this.definitions) {
                await this.getProductDefinitionsCommand.run()
            }

            if (!this.hasLoaded) {
                await this.getMyDocumentsCommand.run()
            }
        }
    }
